import React from 'react';
var NoScript = function (_a) {
    var children = _a.children, _b = _a.wrap, wrap = _b === void 0 ? true : _b;
    return wrap ? React.createElement("noscript", null, children) : React.createElement(React.Fragment, null, children);
};
NoScript.displayName = 'NoScript';
export default NoScript;
//# sourceMappingURL=NoScript.js.map